import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';

import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';
import user from 'features/views/user';
import { USER_ROLE } from 'features/views/user/constants';

export const CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME = 'campaignSubsellerNominations-filter';

const { channel, region, agency, manager } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	channel,
	region,
	agency,
	manager,
};

export default () => ({
	[FIELDS.channel]: {
		deepPath: [FIELDS.channel],
		validations: [],
	},
	[FIELDS.region]: {
		deepPath: [FIELDS.region],
		validations: [
			isRequired({
				// eslint-disable-next-line
				when: ({ formData, reduxState }) => {
					const currentRole = user.selectors.getCurrentRole(reduxState);
					return [USER_ROLE.CENTRAL, USER_ROLE.AGENCY_MANAGER, USER_ROLE.REGION_MANAGER].includes(
						currentRole,
					);
				},
			}),
		],
	},
	[FIELDS.agency]: {
		deepPath: [FIELDS.agency],
		validations: [
			isRequired({
				// eslint-disable-next-line
				when: ({ formData, reduxState }) => {
					const currentRole = user.selectors.getCurrentRole(reduxState);
					return [USER_ROLE.CENTRAL, USER_ROLE.AGENCY_MANAGER, USER_ROLE.REGION_MANAGER].includes(
						currentRole,
					);
				},
			}),
		],
	},
	[FIELDS.manager]: {
		deepPath: [FIELDS.manager],
		validations: [],
	},
});
